module.exports = __webpack_public_path__ + "img/c5201704-3.9d691d58.jpg";